module.exports = __webpack_public_path__ + "img/thunfischbowloben.6bb745f1.png";